import VisionValues from '@screens/vision/values'

export default function VisionValuesPage() {
  return <VisionValues />
}
